import PubSub from "underpub-js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

window.requestAnimationFrame = window.requestAnimationFrame.bind(window);
gsap.registerPlugin(ScrollTrigger);

var Footer = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-Footer',
	};

	$.extend(true, this.options, options);

};

Footer.prototype.init = function() {

	var self = this;

	this.$hamburger = this.options.$el.find(`.${self.options.baseClass}__hamburger`);

	this.$hamburger.on('click', function() {

		PubSub.publish('NavOverlay:show');
		PubSub.publish('NavOverlay:opening');
		
	});

	PubSub.subscribe('NavOverlay:closing', function() {

		self.hamburgerNavClosed();

	});

	PubSub.subscribe('NavOverlay:opening', function() {

		self.hamburgerNavOpen();

	});

	PubSub.subscribe('Footer:showHamburger', function() {
		
		self.showHamburger();

	});

	PubSub.subscribe('Footer:hideHamburger', function() {
		
		self.hideHamburger();

	});
	
	gsap.to( self.options.$el.find(`.${self.options.baseClass}__container`), {
		scrollTrigger: {
			trigger: self.options.$el,
			start: "top bottom",
			end: "top top",
			scrub: true
		},
		yPercent: 0,
		ease: "none"
	});
	


};

Footer.prototype.showHamburger = function() {

	var self = this;

	if (this.$hamburger.hasClass(`${self.options.baseClass}__hamburger--hidden`)) {
		this.$hamburger.removeClass(`${self.options.baseClass}__hamburger--hidden`);
	}

};

Footer.prototype.hideHamburger = function() {

	var self = this;

	if (!this.$hamburger.hasClass(`${self.options.baseClass}__hamburger--hidden`)) {
		this.$hamburger.addClass(`${self.options.baseClass}__hamburger--hidden`);
	}

};

Footer.prototype.hamburgerNavOpen = function() {

	var self = this;

	self.options.$el.find(`.${self.options.baseClass}__hamburger`).addClass(`${self.options.baseClass}__hamburger--closed`);

};

Footer.prototype.hamburgerNavClosed = function() {

	var self = this;

	self.options.$el.find(`.${self.options.baseClass}__hamburger`).removeClass(`${self.options.baseClass}__hamburger--closed`);

};


export default Footer;
